<template>
	<div
		v-editable="blok"
		class="container"
	>
		<h2
			v-if="blok.title"
			class="typo-h2 mb-4 text-heading-primary"
			v-text="blok.title"
		/>
		<p
			v-if="blok.subtitle"
			class="typo-body-m"
			v-text="blok.subtitle"
		/>
		<div class="space-y-4 max-w-screen-md mx-auto mt-4 sm:mt-6">
			<Accordion
				v-for="accordion in blok.content"
				:key="accordion._uid"
				:blok="accordion"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {FaqStoryblok} from '@/storyblok/types';

	interface Props {
		blok: FaqStoryblok
	}

	const props = defineProps<Props>();

	const jsonLd = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: props.blok.content.map((item: any) => ({
			'@type': 'Question',
			name: item.title,
			acceptedAnswer: {
				'@type': 'Answer',
				text: item.content ? renderRichText(item.content) : '',
			},
		})),
	};

	useHead({
		script: [
			{
				type: 'application/ld+json',
				textContent: JSON.stringify(jsonLd),
			},
		],
	});
</script>
